import { Science } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import BuildIcon from "@mui/icons-material/Build";
import CategoryIcon from "@mui/icons-material/Category";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FactoryIcon from "@mui/icons-material/Factory";
import HistoryIcon from "@mui/icons-material/History";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ShieldIcon from "@mui/icons-material/Shield";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { QRCodeSVG } from "qrcode.react";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import MDButton from "components/MDButton";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubModulesByRoleId } from "store";
import Cookies from "universal-cookie";

import Config from "../../config/index";

import JourneyTimeline from "./journeyTimeline";
import Operations from "./operations";
import RepairRecycleModal from "./RepairInfo";
import { getAllDataForDpp } from "../../store";
import QRCodeModal from "./QRCodeModal";
import MiniLogo from "assets/mini-logo.png";

const cookies = new Cookies();

const readOp = (op = {}) => ({
    name: op.operationName || op.operation || op.name || op.processName || op.stageName || "",
    person: op.operatorName || op.operator || op.personName || op.responsiblePerson || op.supervisor || op.person || "",
    plantCode: op.plantCode || op.plant_code || op.plant || "",
    plantLocation: op.plantLocation || op.plant_location || op.location || "",
});




const OperationsTimeline = ({ operationsData }) => {
    const list = Array.isArray(operationsData) ? operationsData : [];
    const canResolve = list.length > 0 && list.some((op) => readOp(op).name);

    if (!canResolve) {
        return <Operations operationsData={operationsData} />;
    }

    return (
        <div className="desktop-ops-timeline">
            {list.map((op, i) => {
                const o = readOp(op);
                const isLast = i === list.length - 1;
                return (
                    <div key={i} className={`desktop-ops-item ${isLast ? "is-last" : ""}`}>
                        {!isLast && <span className="desktop-ops-line" />}
                        <span className="desktop-ops-dot" />
                        <div className="desktop-ops-card">
                            <div className="desktop-ops-title">
                                {o.name}
                                {o.person && <span className="desktop-ops-person"> ({o.person})</span>}
                            </div>
                            <div className="desktop-ops-row">
                                <span className="desktop-ops-key">Plant Code:</span>
                                <span className="desktop-ops-val">{o.plantCode || "—"}</span>
                            </div>
                            <div className="desktop-ops-row">
                                <span className="desktop-ops-key">Plant Location:</span>
                                <span className="desktop-ops-val">{o.plantLocation || "—"}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};


const HierarchyNode = ({ node, isRoot, handleRedirect }) => {
    const [isOpen, setIsOpen] = useState(false);

    const hasDpp = isRoot ? true : !!node.childDpp;

    const displayCode = isRoot
        ? (node.dppCode || node.itemCode)
        : (node.childDpp ? node.childDpp.dppCode : node.itemCode);

    const displayId = isRoot
        ? node.dppId
        : (node.childDpp ? node.childDpp.dppId : null);

    const externalUrl = isRoot
        ? (node.url || null)
        : (node.childDpp ? node.childDpp.url : node.url);

    const childArray = isRoot
        ? node.children
        : (node.childDpp ? node.childDpp.children : []);

    const isExpandable = childArray && childArray.length > 0;

    return (
        <div style={{ marginTop: "8px", width: "100%" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px 12px",
                    background: hasDpp ? "#ffffff" : "#f8fafc",
                    border: "1px solid",
                    borderColor: hasDpp ? "#e2e8f0" : "#eef2ff",
                    borderRadius: "8px",
                    cursor: isExpandable ? "pointer" : "default",
                    boxShadow: hasDpp ? "0 2px 4px rgba(0,0,0,0.02)" : "none"
                }}
                onClick={() => {
                    if (isExpandable) setIsOpen(!isOpen);
                }}
            >
                <div style={{ width: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {isExpandable && (
                        <ExpandMoreIcon
                            style={{
                                fontSize: "20px", color: "#64748b",
                                transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
                                transition: "transform 0.2s ease"
                            }}
                        />
                    )}
                </div>

                <div style={{ flex: 1, fontSize: "14px", wordBreak: "break-all", display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                    {isRoot ? (
                        <span style={{ fontWeight: 700, color: "#0f172a" }}>
                            {displayCode}
                        </span>
                    ) : hasDpp && displayId ? (
                        handleRedirect ? (
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRedirect(e, displayId, displayCode);
                                }}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "4px 12px",
                                    background: "#eff6ff",
                                    color: "#2563eb",
                                    border: "1px solid #bfdbfe",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    textUnderlineOffset: "3px",
                                    transition: "all 0.2s ease"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#dbeafe";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#eff6ff";
                                }}
                            >
                                {displayCode}
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        ) : (
                            <span style={{ fontWeight: 600, color: "#0f172a" }}>
                                {displayCode}
                            </span>
                        )
                    ) : (
                        <span style={{ fontWeight: 500, color: "#94a3b8", display: "flex", alignItems: "center" }}>
                            {displayCode}
                            {/* <span style={{ fontSize: "11px", fontWeight: 600, background: "#e2e8f0", color: "#64748b", padding: "2px 6px", borderRadius: "4px", marginLeft: "6px" }}>
                                (No DPP)
                            </span> */}
                        </span>
                    )}


                    {externalUrl && handleRedirect && (
                        <MDButton
                            color="info"
                            variant="outlined"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                let url = externalUrl;
                                if (!/^https?:\/\//i.test(url)) {
                                    url = 'http://' + url;
                                }
                                window.open(url, "_blank", "noopener,noreferrer");
                            }}
                            sx={{
                                padding: "4px 10px",
                                fontSize: "12px",
                                minHeight: "28px",
                                textTransform: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px"
                            }}
                        >
                            View DPP
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </MDButton>
                    )}
                </div>
            </div>

            {isOpen && isExpandable && (
                <div style={{ paddingLeft: "10px", marginLeft: "18px", borderLeft: "1.5px dashed #cbd5e1", marginTop: "4px" }}>
                    {childArray.map((child, idx) => (
                        <HierarchyNode key={idx} node={child} isRoot={false} handleRedirect={handleRedirect} />
                    ))}
                </div>
            )}
        </div>
    );
};

const DppDesktopView = ({
    mainData,
    treeMapData,
    getAllDataForDpp,
    productImage,
    dppId,
    hasIndustryId,
    hasBatteryIndustry,
    hasSteelIndustry,
    loadDppSidebarSection,
    fetchDppSectionService,
    baseUrl,
    roleName,
    jwtToken,
    handleDocumentClick,
    productsListForDppOptions = [],
    getSubModulesByRoleIdReducer,
    getSubModulesByRoleId,
    downloadReport = true,
    // downloadReport
}) => {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(search);
    const urlDppId = queryParams.get("dppId") || queryParams.get("dppid");
    const urlDppCode = queryParams.get("dppCode") || queryParams.get("dppcode");


    const handleViewMoreInfo = () => {
        try {
            let targetUrl = "";

            if (pathname.toLowerCase().startsWith("/dpp")) {
                targetUrl = pathname + search;
            } else {
                const encodedString = pathname.substring(1);
                targetUrl = atob(encodedString);
            }

            localStorage.setItem("dppRedirectUrl", targetUrl);
            navigate('/login');

        } catch (error) {
            console.error("URL redirect fail ho gaya:", error);
            navigate('/login');
        }
    };

    const hasDppId = Boolean(urlDppId || urlDppCode);
    const isFromQRCode = pathname.toLowerCase() === "/dpp" && hasDppId;

    const loginDetails = cookies.get("loginDetailsForWMS");
    const roleId = loginDetails?.data?.roleId;

    const [showQR, setShowQR] = useState(false);
    const [showDownloadMenu, setShowDownloadMenu] = useState(false);

    const handleTreeRedirect = (e, targetDppId, targetDppCode) => {
        if (!targetDppId) return;
        const matchedOption = productsListForDppOptions?.find((item) => item.value === targetDppId);
        const finalCode = matchedOption ? matchedOption.value : targetDppId;
        const finalLabel = matchedOption ? matchedOption.label : targetDppCode;
        const routeToEncode = `/dpp?dppCode=${finalLabel || ""}`;
        const encodedPath = btoa(routeToEncode);
        const url = `${encodedPath}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const headerRef = useRef(null);
    const imgBoxRef = useRef(null);
    const imgInnerRef = useRef(null);
    const logoBoxRef = useRef(null);
    const isReady = !!mainData && Object.keys(mainData).length > 0;
    const dppCode = mainData?.mainCard?.productDetails?.dppCode;

    const routeToEncode = `/dpp?dppCode=${dppCode || ""}`;
    const encodedPath = btoa(routeToEncode);

    const effectiveBaseUrl = baseUrl || Config?.baseUrl || "";

    const handleDownload = async (isExcel = 1) => {
        try {
            const response = await fetch(
                `${effectiveBaseUrl}/dpp/get_report?roleId=${roleId}&dppCode=${dppCode}&isExcel=${isExcel}`
            );
            if (!response.ok) {
                throw new Error("Failed to download report");
            }
            const result = await response.json();
            if (!result?.data?.base64) {
                throw new Error("Invalid response");
            }
            const base64 = result.data.base64;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
                type: isExcel
                    ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    : "application/json",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = isExcel
                ? "DPP_Report.xlsx"
                : `DPP_Report${dppCode || ""}.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const downloadQRCode = () => {
        const qrCanvas = document.getElementById("mobile-qr-canvas") || document.getElementById("qr-canvas");
        if (!qrCanvas) return;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const width = 600;
        const height = 800;
        canvas.width = width;
        canvas.height = height;

        const drawRoundRect = (x, y, w, h, r) => {
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.lineTo(x + w - r, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + r);
            ctx.lineTo(x + w, y + h - r);
            ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
            ctx.lineTo(x + r, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - r);
            ctx.lineTo(x, y + r);
            ctx.quadraticCurveTo(x, y, x + r, y);
            ctx.closePath();
        };

        ctx.fillStyle = "#f1f5f9";
        ctx.fillRect(0, 0, width, height);

        const cardX = 40;
        const cardY = 40;
        const cardW = width - 80;
        const cardH = height - 80;
        const cornerRadius = 24;

        ctx.shadowColor = "rgba(0, 0, 0, 0.15)";
        ctx.shadowBlur = 40;
        ctx.shadowOffsetY = 15;

        drawRoundRect(cardX, cardY, cardW, cardH, cornerRadius);
        ctx.fillStyle = "#ffffff";
        ctx.fill();

        ctx.shadowColor = "transparent";
        ctx.shadowBlur = 0;
        ctx.shadowOffsetY = 0;

        ctx.save();
        drawRoundRect(cardX, cardY, cardW, cardH, cornerRadius);
        ctx.clip();

        const headerHeight = 170;
        const gradient = ctx.createLinearGradient(cardX, cardY, cardX + cardW, cardY + headerHeight);
        gradient.addColorStop(0, "#0f172a");
        gradient.addColorStop(1, "#0db26b");

        ctx.fillStyle = gradient;
        ctx.fillRect(cardX, cardY, cardW, headerHeight);

        ctx.fillStyle = "#fbbf24";
        ctx.fillRect(cardX, cardY + headerHeight - 4, cardW, 4);

        ctx.fillStyle = "#ffffff";
        ctx.font = "bold 26px Inter, system-ui, sans-serif";
        ctx.textAlign = "center";
        ctx.letterSpacing = "2px";
        ctx.fillText("DIGITAL PRODUCT PASSPORT", width / 2, cardY + 75);

        ctx.fillStyle = "rgba(255, 255, 255, 0.85)";
        ctx.font = "500 16px Inter, system-ui, sans-serif";
        ctx.fillText("Secure & Verified Product Journey", width / 2, cardY + 115);

        ctx.restore();

        const qrSize = 300;
        const qrX = (width - qrSize) / 2;
        const qrY = cardY + headerHeight + 70;

        ctx.shadowColor = "rgba(0, 0, 0, 0.08)";
        ctx.shadowBlur = 20;
        ctx.shadowOffsetY = 10;
        drawRoundRect(qrX - 25, qrY - 25, qrSize + 50, qrSize + 50, 16);
        ctx.fillStyle = "#ffffff";
        ctx.fill();

        ctx.shadowColor = "transparent";
        ctx.strokeStyle = "#f1f5f9";
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);

        ctx.fillStyle = "#475569";
        ctx.font = "17px Inter, system-ui, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText("Scan to access complete lifecycle &", width / 2, qrY + qrSize + 85);
        ctx.fillText("authenticity details of this product.", width / 2, qrY + qrSize + 115);

        ctx.fillStyle = "#cbd5e1";
        ctx.font = "bold 13px Inter, system-ui, sans-serif";
        ctx.letterSpacing = "1px";
        ctx.fillText("POWERED BY MOBILLOR", width / 2, cardY + cardH - 35);

        const pngUrl = canvas.toDataURL("image/png");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `DPP_QR_${dppCode || "Card"}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    useEffect(() => {
        if (typeof getSubModulesByRoleId === "function") {
            getSubModulesByRoleId(roleId, jwtToken);
        }
    }, [roleId]);

    const [modulesData, setModulesData] = useState([]);
    useEffect(() => {
        setModulesData(
            getSubModulesByRoleIdReducer?.subModulesByRoleData?.data
                ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
                : [],
        );
    }, [getSubModulesByRoleIdReducer]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (imgBoxRef.current && !imgBoxRef.current.contains(event.target)) {
                setShowDownloadMenu(false);
            }
        };

        if (showDownloadMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDownloadMenu]);

    const tabsRef = useRef(null);
    const [tabsThumb, setTabsThumb] = useState({ width: 100, left: 0 });

    const updateTabsThumb = () => {
        const el = tabsRef.current;
        if (!el || !el.scrollWidth) return;
        setTabsThumb({
            width: Math.min(100, (el.clientWidth / el.scrollWidth) * 100),
            left: (el.scrollLeft / el.scrollWidth) * 100,
        });
    };

    useEffect(() => {
        if (!isReady) return undefined;
        const t = setTimeout(updateTabsThumb, 0);
        window.addEventListener("resize", updateTabsThumb);
        return () => {
            clearTimeout(t);
            window.removeEventListener("resize", updateTabsThumb);
        };
    }, [isReady, modulesData]);

    const hasModuleAction = (moduleUuid, actionUuid) => {
        // if (isFromQRCode) return true;
        const found = modulesData?.find((m) => m.moduleId === moduleUuid);
        return found ? found.actionId.includes(actionUuid) : null;
    };

    const viewManufacturing = hasModuleAction("d51e5caa-b714-4739-877a-3b78d6f9d263", "6fd9218e-53e3-49ec-85bc-ef986f9ede86");
    const viewRm = hasModuleAction("852fd581-2cd9-40d1-b0f6-e29dd61566ff", "94e1aedf-8637-4d27-9079-2812f320e458");
    const viewProductTesting = hasModuleAction("16cc0217-cbce-4e3f-874b-89b3fbdd0232", "896c7b19-7fe5-4306-9f06-2735e57a7b84");
    const viewValidation = hasModuleAction("b3605909-30dc-4c9f-8918-f1ef34354fd2", "acf6e194-8a3f-4c7f-98b7-9cc2151ed763");
    const viewCoc = hasModuleAction("269b317f-3fc3-4ce8-b885-0817acf36a66", "1f130e9a-11bf-4ad3-b690-4fcefedfbb44");
    const viewDurability = hasModuleAction("5e690abe-d7a1-4e45-8782-43409b4edab2", "24059d11-ee70-4a0d-a132-56bf7195de49");
    const viewRepairValue = hasModuleAction("9f3b7cf0-eb97-4567-8d4a-711868269662", "a0f6b96e-282c-4349-b655-f08f172739f8");
    const viewPackaging = hasModuleAction("7e02c688-4e21-4805-9f51-2320dda92382", "825e65a6-0f01-4fe7-91a1-63cb571b093a");
    const viewUsageHistory = hasModuleAction("efdda63c-9aed-4cef-8fab-8a4bfb09c4f4", "f5bbfe82-821f-4980-a9cc-cb63a8e141ff");
    const viewSocialCompliance = hasModuleAction("013a3276-d1db-4051-b489-b199b4710cf4", "3dce3a16-274c-4937-92cc-df13fa7c6c8d");

    const [selectedJourneyKey, setSelectedJourneyKey] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mobileActiveStep, setMobileActiveStep] = useState(null);
    const [itemsDataForRM, setItemsDataForRM] = useState([]);
    const [techSectionData, setTechSectionData] = useState(null);

    const [openSections, setOpenSections] = useState({
        operations: true,
        detailedInfo: true,
        careInstructions: true,
        materialsUsed: true,
        productTestTypes: true,
        chemicalAnalysis: true,
        rawMaterialsDetails: true,
        journeyTimeline: true,
        repairRecycle: true,
    });

    const toggleSection = (key) =>
        setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

    const [openMaterialModal, setOpenMaterialModal] = useState(false);
    const [selectedMaterialData, setSelectedMaterialData] = useState(null);
    const [openViewItemsModal, setOpenViewItemsModal] = useState(false);
    const [viewItemsData, setViewItemsData] = useState(null);
    const [testType, setTestType] = useState("");

    const openTestModal = (data, type) => {
        setViewItemsData(data);
        setTestType(type);
        setOpenViewItemsModal(true);
    };

    const handleViewClick = (dppCode) => {
        if (!dppCode) return;
        const matchedOption = productsListForDppOptions?.find((item) => item.value === dppCode);
        const targetCode = matchedOption ? matchedOption.value : dppCode;
        const targetLabel = matchedOption ? matchedOption.label : dppCode;
        const routeToEncode = `/dpp?dppCode=${targetLabel || targetCode}`;
        const encodedPath = btoa(routeToEncode);
        const url = `${encodedPath}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const journeySteps = [
        { key: "manufacturer", route: "manufacturing", view: viewManufacturing, icon: Inventory2Icon, color: "#FF5F15" },
        { key: "rmTraceability", route: "raw_material", view: viewRm, icon: CategoryIcon, color: "#0000FF" },
        { key: "productTests", route: "product_testing", view: viewProductTesting, icon: Science, color: "black" },
        { key: "technicalDocuments", route: "technical_documents_bydpp", view: viewValidation, icon: ArticleIcon, color: "#F59E0B" },
        { key: "chainOfCustody", route: "coc", view: viewCoc, icon: LocalShippingIcon, color: null },
        { key: "durabilityAndLifespan", route: "durability_bydpp", view: viewDurability, icon: ShieldIcon, color: "#A78BFA" },
        { key: "returnRepairInfo", route: "repair_recycle_value", view: viewRepairValue, icon: BuildIcon, color: "#60A5FA" },
        { key: "packagingWasteManagement", route: "packaging_waste_management", view: viewPackaging, icon: FactoryIcon, color: "#FF69B4" },
        { key: "productUsageHistory", route: "product_usage_history", view: viewUsageHistory, icon: HistoryIcon, color: "#9C27B0" },
        { key: "socialCompliance", route: "environmental", view: viewSocialCompliance, icon: EnergySavingsLeafIcon, color: null },
    ];

    const formatFloat = (value, decimals = 2) => {
        if (value === null || value === undefined || value === "") return "—";
        if (typeof value === "number") return value.toFixed(decimals);
        if (typeof value === "string") {
            const num = parseFloat(value);
            return isNaN(num) ? value : num.toFixed(decimals);
        }
        return String(value);
    };

    const fetchSectionData = async (route, preferService = false) => {
        if (!preferService && typeof loadDppSidebarSection === "function") {
            return (await loadDppSidebarSection(route)) || null;
        }
        if (typeof fetchDppSectionService === "function") {
            const res = await fetchDppSectionService({ baseUrl, roleName, route, dppId, jwtToken });
            return res?.data || null;
        }
        return null;
    };

    const requestIdRef = useRef(0);

    const openJourneyStep = async (step) => {
        if (!dppId || !step) return;
        const reqId = ++requestIdRef.current;
        setSelectedJourneyKey(step.key);
        setMobileActiveStep(null);
        setItemsDataForRM([]);
        setTechSectionData(null);
        setLoading(true);

        const techDocsPromise =
            step.key === "technicalDocuments"
                ? Promise.resolve(null)
                : fetchSectionData("technical_documents_bydpp", true).catch((err) => {
                    console.error("Error fetching technical documents:", err);
                    return null;
                });

        try {
            if (step.key === "rmTraceability") {
                const [rawData, rmTraceData] = await Promise.all([
                    fetchDppSectionService({ baseUrl, roleName, route: "raw_material", dppId, jwtToken }),
                    fetchDppSectionService({
                        baseUrl,
                        roleName,
                        route: "dpp_id_for_item_details",
                        dppId,
                        jwtToken,
                        basePath: "/dpp/rm_traceability",
                    }),
                ]);
                if (reqId !== requestIdRef.current) return;
                setMobileActiveStep(rawData?.data || null);
                setItemsDataForRM(rmTraceData?.data || []);
            } else {
                const data = await fetchSectionData(step.route);
                if (reqId !== requestIdRef.current) return;
                setMobileActiveStep(data || null);
            }
            const docsData = await techDocsPromise;
            if (reqId !== requestIdRef.current) return;
            setTechSectionData(docsData || null);
        } catch (err) {
            if (reqId !== requestIdRef.current) return;
            console.error("Error fetching stage data for view:", err);
            setMobileActiveStep(null);
        } finally {
            if (reqId === requestIdRef.current) setLoading(false);
        }
    };

    const prevDppIdRef = useRef(dppId);
    useEffect(() => {
        if (prevDppIdRef.current === dppId) return;
        prevDppIdRef.current = dppId;

        requestIdRef.current += 1;
        setMobileActiveStep(null);
        setItemsDataForRM([]);
        setTechSectionData(null);
        setSelectedMaterialData(null);
        setOpenMaterialModal(false);
        setOpenViewItemsModal(false);
        setViewItemsData(null);
        setLoading(false);
        setShowDownloadMenu(false);

        const step = journeySteps.find((s) => s.key === selectedJourneyKey);
        if (step && dppId) {
            openJourneyStep(step);
        } else {
            setSelectedJourneyKey(null);
        }
    }, [dppId]);

    const permissionsLoaded = isFromQRCode || (modulesData && modulesData.length > 0);

    useEffect(() => {
        if (isReady && mainData?.productLifecycleJourney && !selectedJourneyKey && dppId && permissionsLoaded) {
            const validSteps = journeySteps.filter((step) => {
                if (!roleId && step.key !== "technicalDocuments") {
                    return false;
                }
                if (roleId && !step.view) {
                    return false;
                }
                // if (!step.view) return false;
                const stageData = mainData.productLifecycleJourney[step.key];
                const orderNumber = stageData?.orderNumber;
                const isAvailable =
                    orderNumber !== undefined &&
                    orderNumber !== null &&
                    orderNumber !== "n/a" &&
                    orderNumber !== "" &&
                    String(orderNumber).trim() !== "0";
                return isAvailable;
            });

            if (validSteps.length > 0) {
                const manufacturingStep = validSteps.find((step) => step.key === "manufacturer");
                let stepToOpen = null;
                if (manufacturingStep) {
                    stepToOpen = manufacturingStep;
                } else {
                    validSteps.sort((a, b) => {
                        const numA = Number(mainData.productLifecycleJourney[a.key].orderNumber) || 999;
                        const numB = Number(mainData.productLifecycleJourney[b.key].orderNumber) || 999;
                        return numA - numB;
                    });
                    stepToOpen = validSteps[0];
                }
                openJourneyStep(stepToOpen);
            }
        }
    }, [isReady, mainData, dppId, selectedJourneyKey, permissionsLoaded]);

    if (!mainData || Object.keys(mainData)?.length === 0) {
        return (
            <div style={{ width: "100%", maxWidth: "100%", overflowX: "hidden", padding: "16px" }}>
                <style>{`
          @keyframes skeleton-loading {
            0% { opacity: 0.6; }
            50% { opacity: 1; }
            100% { opacity: 0.6; }
          }
        `}</style>
                <div style={{ background: "white", borderRadius: "10px", padding: "20px" }}>
                    <div style={{ display: "flex", gap: "24px" }}>
                        <div style={{ width: "150px", height: "150px", borderRadius: "8px", background: "#f4f4f4", animation: "skeleton-loading 1.5s infinite" }} />
                        <div style={{ flex: 1, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" }}>
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                                <div key={i}>
                                    <div style={{ height: "14px", width: "40%", borderRadius: "4px", background: "#f4f4f4", animation: "skeleton-loading 1.5s infinite", marginBottom: "8px" }} />
                                    <div style={{ height: "18px", width: "70%", borderRadius: "4px", background: "#f4f4f4", animation: "skeleton-loading 1.5s infinite" }} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const productDetails = mainData?.mainCard?.productDetails || {};
    const brandLogoUrl = productDetails?.brandLogoUrl || null;

    const co2Value = productDetails?.carbonFootprint || mobileActiveStep?.mainHeader?.carbonFootprint || "—";
    const energyValue = mobileActiveStep?.mainHeader?.energyUsage || mobileActiveStep?.mainHeader?.electricityConsumption || "—";
    const waterValue = mobileActiveStep?.mainHeader?.waterUsage || mobileActiveStep?.mainHeader?.waterConsumption || "—";
    const recyclabilityValue = mobileActiveStep?.mainHeader?.recyclabilityScore || "—";

    const moduleName = mobileActiveStep?.mainHeader?.moduleName;
    const pickList = (key) => mobileActiveStep?.[key]?.length > 0 ? mobileActiveStep[key] : techSectionData?.[key] || [];
    const documentsList = pickList("technicalDocuments");
    const certificationsList = pickList("certifications");
    const testCertsList = pickList("testCertificatesName");
    const supplierCertsList = pickList("supplierCertificatesName");
    const otherCertsList = pickList("othersCertificatesName");

    const certGroups = [
        { title: "Certifications & Compliance", items: certificationsList.map((c) => (typeof c === "string" ? c : c?.docType || c?.name)) },
        { title: "Test Certificates", items: testCertsList.map((c) => c?.docType) },
        { title: "Supplier Certificates", items: supplierCertsList.map((c) => c?.docType) },
        { title: "Other Certificates", items: otherCertsList.map((c) => c?.docType) },
    ]
        .map((g) => ({ ...g, items: g.items.filter(Boolean) }))
        .filter((g) => g.items.length > 0);

    const opsData = mobileActiveStep?.operations;
    const detailInfo = mobileActiveStep?.detailInformation || {};
    const usageInfo = mobileActiveStep?.productUsageHistory || {};
    let detailRows = [];
    let showDetailedInfo = false;

    if (moduleName === "Manufacturing") {
        showDetailedInfo = true;
        detailRows = [
            ["Production Date", detailInfo.productionDate || "—"],
            ["Batch Number", detailInfo.batchNumber || "—"],
            ["Workers", detailInfo.workers || "—"],
            ["Units Produced", detailInfo.unitsProduced || "—"],
            ["Factory Manager", detailInfo.factoryManager || "—"],
            ["Quality Yield", detailInfo.qualityYield ? `${detailInfo.qualityYield} %` : "—"],
            ["Waste Generated", detailInfo.wasteGenerated ? `${detailInfo.wasteGenerated} %` : "—"],
            ["Company Name", detailInfo.companyName || "—"],
            ["City", detailInfo.city || "—"],
            ["Street", detailInfo.street || "—"],
            ["Country", detailInfo.nationalCode || "—"],
            ["Item Code", detailInfo.itemCode || "—"],
            ["Item Description", detailInfo.itemDescription || "—"],
            ["Variant Name", detailInfo.variantName || "—"],
            ["Quantity", `${detailInfo.quantity || "—"} ${detailInfo.quantityUOM || ""}`.trim()],
            ["Actual Mass", `${detailInfo.actualMass || "—"} ${detailInfo.actualMassUOM || ""}`.trim()],
        ];
    } else if (moduleName === "Chain Of Custody") {
        showDetailedInfo = true;
        detailRows = [
            ["Total Transit Time (days)", detailInfo.totalTransitTime ?? "—"],
            ["Handling Events", detailInfo.handlingEvents ? `${detailInfo.handlingEvents} Stages` : "—"],
            ["Tracking Id", detailInfo.trackingId ?? "—"],
            ["Traceability Status", detailInfo.traceabilityStatus ?? "—"],
            ["Transit Mode", detailInfo.transitMode ?? "—"],
            ["Last Scan", detailInfo.lastScan ?? "—"],
            hasBatteryIndustry && ["Temperature Range", detailInfo.temperatureRange ?? "—"],
        ].filter(Boolean);
    } else if (moduleName === "Durability") {
        showDetailedInfo = true;
        detailRows = [["Expected Lifespan", detailInfo.expectedLifespan || "—"]];
        if (hasIndustryId) {
            detailRows.push(
                ["Abrasion Resistance", detailInfo.abrasionResistance ? `${detailInfo.abrasionResistance} Cycles` : "—"],
                ["Color Fastness", detailInfo.colorFastness ? `Rating ${detailInfo.colorFastness}` : "—"],
                ["Shrinkage Percentage", detailInfo.shrinkagePercentage ? `${detailInfo.shrinkagePercentage} %` : "—"],
                ["Humidity Resistance", detailInfo.humidityResistance || "—"],
                ["Wear Resistance", detailInfo.wearResistance || "—"],
                ["Pilling Resistance", detailInfo.pillingResistance ? `${detailInfo.pillingResistance} %` : "—"],
            );
        } else {
            detailRows.push(["Temperature Range", detailInfo.temperatureRange || "—"]);
            if (hasSteelIndustry) {
                detailRows.push(["Material Strength", detailInfo.materialStrength || "—"]);
            }
            detailRows.push(["Test Results", detailInfo.testResults || "—"]);
            if (hasBatteryIndustry) {
                detailRows.push(["Battery Degradation", detailInfo.batteryDegradation || "—"],
                    ["Drop Test", detailInfo.dropTest || "—"],
                    ["State Of Health", detailInfo.stateOfHealth || "—"]);
            }
        }
        detailRows.push(["Warranty", detailInfo.warranty || "—"], ["Quality Score", detailInfo.qualityScore || "—"]);
    } else if (moduleName === "Packaging & Waste Management") {
        showDetailedInfo = true;
        detailRows = [
            ["Packaging Weight (Kg)", detailInfo.packagingWeight || "—"],
            ["Material Source", detailInfo.materialSource || "—"],
            hasBatteryIndustry && ["Plastic Content", detailInfo.plasticContent ? `${detailInfo.plasticContent} %` : "—"],
            hasBatteryIndustry && ["Bio Degradability", detailInfo.biodegradability ? `${detailInfo.biodegradability} %` : "—"],
            ["Carbon Footprint", detailInfo.carbonFootprint ? `${detailInfo.carbonFootprint} kg CO₂e` : "—"],
            ["Waste Generation", detailInfo.wasteGeneration ? `${detailInfo.wasteGeneration} %` : "—"],
            ["Reusability", detailInfo.reusability ? `${detailInfo.reusability} %` : "—"],
            ["Disposal Instructions", detailInfo.disposalInstructions || "—"],
            ["Take Back Program", detailInfo.takeBackProgram || "—"],
        ].filter(Boolean);
    } else if (moduleName === "Product Usage History") {
        showDetailedInfo = true;
        detailRows = [
            ["Total Operating Time", usageInfo.totalOperatingTime || "—"],
            hasBatteryIndustry && ["Total Charging Cycles", usageInfo.totalChargingCycles || "—"],
            hasBatteryIndustry && ["Total Discharging Cycles", usageInfo.totalDischargingCycles || "—"],
            hasBatteryIndustry && ["Average SOC", usageInfo.averageSoc || "—"],
            ["Min/Max Operating Temp", `${usageInfo.minOperatingTemp || "—"} / ${usageInfo.maxOperatingTemp || "—"}`],
            hasBatteryIndustry && ["Min/Max Charging Temp", `${usageInfo.minChargingTemp || "—"} / ${usageInfo.maxChargingTemp || "—"}`],
            ["Min/Max Storage Temp", `${usageInfo.minStorageTemp || "—"} / ${usageInfo.maxStorageTemp || "—"}`],
            hasBatteryIndustry && ["Total Energy Charged", usageInfo.totalEnergyCharged || "—"],
            hasBatteryIndustry && ["Total Energy Discharged", usageInfo.totalEnergyDischarged || "—"],
            hasBatteryIndustry && ["Charging Method", usageInfo.chargingMethod || "—"],
            hasBatteryIndustry && ["Charging Frequency", usageInfo.chargingFrequency || "—"],
            hasBatteryIndustry && ["Avg Charging Duration", usageInfo.averageChargingDuration || "—"],
            hasBatteryIndustry && ["Avg Charging Rate", usageInfo.averageChargingRate || "—"],
        ].filter(Boolean);
    } else if (moduleName === "Environmental Impact & Sustainability") {
        showDetailedInfo = true;
        detailRows = [
            ["Total CO₂ Emissions", `${formatFloat(detailInfo.totalCO2Emissions)} kg CO₂`],
            ["Raw Materials (CO₂ Emissions)", `${formatFloat(detailInfo.rawMaterial)} kg CO₂`],
            ["Manufacturing (CO₂ Emissions)", `${formatFloat(detailInfo.manufacturing)} kg CO₂`],
            ["Carbon Offset", `${formatFloat(detailInfo.carbonOffset)} kg CO₂`],
            ["Recycled Content Used", `${formatFloat(detailInfo.recycledContent)} %`],
            ["Water Footprint", detailInfo.WaterFootprint ?? "—"],
            ["Energy Source", detailInfo.energySource ?? "—"],
            ["Sustainability Score (%)", detailInfo.sustainabilityScore != null ? `${detailInfo.sustainabilityScore} %` : "—"],
            ["End of Life Recovery (%)", `${detailInfo.endOfLifeRecovery || "—"} %`],
            ["Environmental Grade", detailInfo.environmentalGrade || "—"],
            ["Renewable Energy Used", detailInfo.renewableEnergyUsed || "—"],
            hasBatteryIndustry && ["Repaired Parts Value", detailInfo.repairedPartsValue || "—"],
        ].filter(Boolean);
    } else if (moduleName === "Repair, Remanufacture & Recycle") {
        showDetailedInfo = true;
        detailRows = [
            ["Return Date", detailInfo.returnDate ? String(detailInfo.returnDate).slice(0, 10) : "-"],
            ["Repair Actions", detailInfo.repairActions ? String(detailInfo.repairActions).slice(0, 10) : "-"],
            (hasBatteryIndustry || hasIndustryId) && ["Second Life Suitable", detailInfo.isSecondLifeSuitable ? String(detailInfo.isSecondLifeSuitable).slice(0, 10) : "-"],
            (hasBatteryIndustry || hasIndustryId) && ["Second Life Duration", detailInfo.secondLifeDuration ? String(detailInfo.secondLifeDuration).slice(0, 10) : "-"],
            (hasBatteryIndustry || hasIndustryId) && ["Reuse Potential", detailInfo.reusePotential ? String(detailInfo.reusePotential).slice(0, 10) : "-"],
            ["Description", detailInfo.description ? (detailInfo.description.length > 50 ? `${detailInfo.description.slice(0, 50)}...` : detailInfo.description) : "—"],

        ].filter(Boolean);
    }

    const showCareInstructions = moduleName === "Durability" && hasIndustryId;
    const careRows = [
        ["Wash Temperature", mobileActiveStep?.careAndUseInstructions?.washTemperature ? `${mobileActiveStep.careAndUseInstructions.washTemperature} °C` : "—"],
        ["Ironing Instructions", mobileActiveStep?.careAndUseInstructions?.ironingInstructions || "—"],
        ["Dry Clean Status", mobileActiveStep?.careAndUseInstructions?.dryCleanStatus || "—"],
        ["Tumble Dry Instructions", mobileActiveStep?.careAndUseInstructions?.tumbleDryInstructions || "—"],
        ["Bleach Allowed", mobileActiveStep?.careAndUseInstructions?.bleachAllowed || "—"],
    ];

    const isRawMaterialModule = moduleName === "Raw Material";
    const uniqueRmItems = (itemsDataForRM || []).filter((value, index, self) => index === self.findIndex((t) => t.rmItemCode === value.rmItemCode));

    const isEmptyVal = (v) => {
        if (v === null || v === undefined) return true;
        const t = String(v).trim();
        return t === "" || /^[—-](\s|$)/.test(t);
    };
    const rowsHaveData = (rows) => (rows || []).some(([, v]) => !isEmptyVal(v));

    const chemRows = mobileActiveStep?.chemicalAnalysis
        ? [
            ["Mass Fraction AI", mobileActiveStep.chemicalAnalysis.massFraction_AI],
            ["Mass Fraction BE", mobileActiveStep.chemicalAnalysis.massFraction_Be],
            ["Mass Fraction C", mobileActiveStep.chemicalAnalysis.massFraction_C],
            ["Mass Fraction CR", mobileActiveStep.chemicalAnalysis.massFraction_Cr],
            ["Mass Fraction CU", mobileActiveStep.chemicalAnalysis.massFraction_Cu],
            ["Mass Fraction MN", mobileActiveStep.chemicalAnalysis.massFraction_Mn],
            ["Mass Fraction NB", mobileActiveStep.chemicalAnalysis.massFraction_Nb],
            ["Mass Fraction P", mobileActiveStep.chemicalAnalysis.massFraction_P],
            ["Mass Fraction PB", mobileActiveStep.chemicalAnalysis.massFraction_Pb],
            ["Mass Fraction MO", mobileActiveStep.chemicalAnalysis.massFraction_Mo],
        ]
        : [];

    const hasTestData = (t) => !!t && Object.values(t).some((v) => !isEmptyVal(v));
    const hasProductTestData = hasIndustryId
        ? hasTestData(mobileActiveStep?.textileTest)
        : hasBatteryIndustry
            ? hasTestData(mobileActiveStep?.thermalStabilityTest) || hasTestData(mobileActiveStep?.shortCircuitOverchargeTest)
            : hasTestData(mobileActiveStep?.notchimpactTest) || hasTestData(mobileActiveStep?.tensileTest) || hasTestData(mobileActiveStep?.hardnessTest);

    const testModalFields = [
        ["Yield Test Name", "yiTestName", (v) => v],
        ["Abrasion Resistance", "abrasionResistance", (v) => `${v} Cycles`],
        ["Overcharge Test", "overchargeTest", (v) => v],
        ["Overcharge Test Value", "overchargeTestValue", (v) => v],
        ["Short Circuit Test", "shortCircuitTest", (v) => v],
        ["Short Circuit Test Value", "shortCircuitTestValue", (v) => v],
        ["Pilling Resistance", "pillingResistance", (v) => `${v} %`],
        ["Color Fastness", "colorFastness", (v) => `${v} / 5`],
        ["Shrinkage Percentage", "shrinkagePercentage", (v) => `${v} %`],
        ["Yield Methodology", "yiMethodology", (v) => v],
        ["Tensile Test Name", "teTestName", (v) => v],
        ["Tensile Strength Mean", "tensileStrengthMean", (v) => v],
        ["Hardness Test Name", "hrTestName", (v) => v],
        ["Hardness Mean", "hardnessMean", (v) => v],
        ["Hardness Individual Values", "hardnessIndividualValues", (v) => v],
        ["Impact Test Name", "imTestName", (v) => v],
        ["Notch Impact Strength Mean", "notchimpactStrengthMean", (v) => v],
        ["Impact LL", "impactLL", (v) => v],
        ["Impact UL", "impactUL", (v) => v],
        ["Impact UOM", "impactUOM", (v) => v],
        ["Yield Proof Strength Mean", "yeildProofStrengthMean", (v) => v],
        ["Yield LL", "yieldLL", (v) => v],
        ["Yield UL", "yieldUL", (v) => v],
        ["Yield UOM", "yieldUOM", (v) => v],
        ["Tensile Methodology", "teMethodology", (v) => v],
        ["Tensile LL", "tensileLL", (v) => v],
        ["Tensile UL", "tensileUL", (v) => v],
        ["Tensile UOM", "tensileUOM", (v) => v],
        ["Impact Methodology", "imMethodology", (v) => v],
        ["HR Methodology", "hrMethodology", (v) => v],
        ["HRC LL", "hrcLL", (v) => v],
        ["HRC UL", "hrcUL", (v) => v],
        ["HR UOM", "hrUOM", (v) => v],
        ["HB Test Name", "hbTestName", (v) => v],
        ["HB Methodology", "hbMethodology", (v) => v],
        ["HB LL", "hbLL", (v) => v],
        ["HB UL", "hbUL", (v) => v],
        ["HB UOM", "hbUOM", (v) => v],
        ["Impact Test Name (CH)", "impactTestName", (v) => v],
        ["Impact Methodology (CH)", "impactMethodology", (v) => v],
        ["CH LL", "chLL", (v) => v],
        ["CH UL", "chUL", (v) => v],
        ["CH UOM", "chUOM", (v) => v],
    ];
    const thermalFields = [
        ["Test Result", "testResult", (v) => v],
        ["Min Operating Temp", "minOperatingTemp", (v) => v],
        ["Max Operating Temp", "maxOperatingTemp", (v) => v],
        ["Thermal Stability Test Temp", "thermalStabilityTestTemp", (v) => v],
        ["Thermal Runaway Onset Temp", "thermalRunawayOnsetTemp", (v) => v],
        ["Temperature Rise", "temperatureRise", (v) => v],
        ["Thermal Exposure Duration", "thermalExposureDuration", (v) => v],
    ];

    const testModalTitle =
        (testType === "tensileTest" && "Tensile Test") ||
        (testType === "hardnessTest" && "Hardness Test") ||
        (testType === "notchimpactTest" && "Notch Impact Test") ||
        (testType === "textileTest" && "Textile Test") ||
        (testType === "thermalStability" && "Thermal Stability Test") ||
        (testType === "shortCircuitOverchargeTest" && "Short Circuit & Overcharge Test") ||
        "";

    // Check if hierarchy data exists
    const hasHierarchy = treeMapData && Object.keys(treeMapData).length > 0;

    return (
        <div className="dpp-desktop-container">
            <style>{`
        .dpp-desktop-container {
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          box-sizing: border-box;
          padding: 5px 0px;
          display: flex;
          flex-direction: column;
          gap: 5px;
          font-family: Inter, system-ui, -apple-system, sans-serif;
          background-color: #f8fafc;
        }
 
        .desktop-product-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.04);
          border: 1px solid #e2e8f0;
          display: flex;
          gap: 42px;
          align-items: flex-start;
        }

        .desktop-product-left {
          flex: 0 0 220px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          position: relative;
        }

  

    .desktop-img-box {
  position: relative;
  width: 100%;
  height: 220px;
  border-radius: 12px;
  background: #f8fafc; 
  border: 1px solid #e2e8f0; 
  display: flex;
  align-items: center;
  justify-content: center; 
}

        .desktop-img-box img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          border-radius: 12px;  
        }

        .desktop-brand-logo {
          max-width: 140px;
          max-height: 60px;
          object-fit: contain;
        }

 

        .desktop-img-share-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.95);
  /* Ekdum patli aur halki border */
  border: 0.5px solid rgba(0, 0, 0, 0.08); 
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  /* Soft aur clean shadow */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  z-index: 10;
}
 

        .desktop-img-share-btn:hover { 
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12); /* Hover par shadow thodi clear hogi */
}

 .mobile-image-download-menu {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 6px;
          background: #ffffff;
          border-radius: 14px;
          padding: 10px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 160px;
          z-index: 100;
          animation: popUpFade 0.2s ease-out;
        }

         .mobile-popup-header {
          font-size: 11px;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding-bottom: 4px;
          border-bottom: 1px solid #f1f5f9;
          text-align: center;
        }

.desktop-img-share-btn:active { 
  transform: scale(0.95); 
}

       .desktop-download-menu {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 10px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid #f1f5f9;
  padding: 16px;
  min-width: 180px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 12px; /* Buttons ke beech ka gap */
}

        /* Right Side: Data Grid */
        .desktop-product-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        
        .desktop-product-title {
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 8px;
          padding-bottom: 8px;
          border-bottom: 1px solid #e2e8f0;
        }

        .desktop-details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px 16px;
        }

        .desktop-details-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .desktop-details-label {
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .desktop-details-val {
          font-size: 14px;
          font-weight: 700;
          color: #0f172a;
          word-break: break-word;
        }

        /* Journey Timeline nested box fix */
        .clean-journey-timeline > div {
           border: none !important;
           box-shadow: none !important;
           padding: 0 !important;
           background: transparent !important;
           margin: 0 !important;
        }

        .desktop-impact-container {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 20px 24px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.02);
          height: 100%; 
          box-sizing: border-box;
        }
        
        .desktop-impact-title {
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 16px;
          text-align: center;
        }

       .desktop-impact-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);  
          gap: 12px;
          width: 100%;
        }
        
        /* 2x2 grid if side-by-side, 1x4 if full width */
        .has-hierarchy .desktop-impact-grid {
          grid-template-columns: repeat(2, 1fr);
        }
        .no-hierarchy .desktop-impact-grid {
          grid-template-columns: repeat(4, 1fr);
        }

       .desktop-impact-tile {
          background: #eef6ff;
          border-radius: 10px;
          padding: 8px 10px; 
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 4px;  
          border: 1px solid #dbeafe;
          min-height: auto; 
          justify-content: center;
        }

       .desktop-impact-tile-label { 
          font-size: 10px; 
          color: #475569; 
          font-weight: 700; 
          text-transform: uppercase; 
          line-height: 1;
        }
        
       .desktop-impact-tile-icon { 
          width: 20px;  
          height: 20px; 
          color: #2563eb; 
        }
        
      .desktop-impact-tile-val { 
          font-size: 13px; 
          font-weight: 800; 
          color: #0f172a; 
          line-height: 1;
          margin-top: 2px;
        }
 
        .desktop-lifecycle-container {
          background: #ffffff;
          border-radius: 16px;
          padding: 20px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        }

        .desktop-lifecycle-header {
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 20px;
        }

        .desktop-tabs-wrapper {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          padding-bottom: 12px;
          margin-bottom: 24px;
          border-bottom: 1px solid #f1f5f9;
        }
        .desktop-tabs-wrapper::-webkit-scrollbar { height: 6px; }
        .desktop-tabs-wrapper::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        .desktop-tab-btn {
          flex: 0 0 auto;
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid #cbd5e1;
          background: #f8fafc;
          color: #334155;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.2s ease;
        }
        .desktop-tab-btn:hover { background: #e2e8f0; }
        .desktop-tab-btn.active {
          background: #3b82f6;
          color: #ffffff;
          border-color: #3b82f6;
          box-shadow: 0 4px 12px rgba(59,130,246,0.3);
        }
        .desktop-tab-btn.unavailable { opacity: 0.5; pointer-events: none; }

        /* ---------- INNER STAGE SPLIT (Inside the 8-column Lifecycle block) ---------- */
        /* Exact 50-50 split for inner details to prevent squeezing */
        .desktop-stage-split {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px; 
          align-items: start;
        }

        .desktop-stage-col {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
 
        /* Clean and Borderless KPIs */
        .desktop-kpi-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; width: 100%; }
        .desktop-kpi-card { display: flex; flex-direction: column; gap: 4px; padding-bottom: 6px; border-bottom: 1px solid #f1f5f9; }
        .desktop-kpi-label { font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; margin-bottom: 2px; }
        .desktop-kpi-val { font-size: 13px; font-weight: 700; color: #0f172a; word-break: break-word; line-height: 1.2; }
        
        /* Material/Chips */
        .desktop-material-card { background: #f8fafc; border-radius: 8px; padding: 12px 14px; border: 1px solid #e2e8f0; display: flex; align-items: center; gap: 8px; font-size: 13px; flex-wrap: wrap; margin-top: 4px; }
        .desktop-material-chip { background: #eff6ff; color: #1d4ed8; padding: 4px 10px; border-radius: 6px; font-weight: 600; font-size: 12px; border: 1px solid #bfdbfe; }
        .desktop-material-chip.clickable {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .desktop-material-chip.clickable:hover { background: #dbeafe; }
 
        .clean-nested-box > div {
           border: none !important;
           box-shadow: none !important;
           padding: 0 !important;
           background: transparent !important;
           margin: 0 !important;
        }

        .desktop-accordion { background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.02); }
        .desktop-accordion-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; cursor: pointer; font-weight: 700; font-size: 15px; color: #0f172a; background: #f8fafc; border-bottom: 1px solid #e2e8f0; }
         
            .desktop-accordion-body {
            padding: 12px 16px;
            background-color: #ffffff;  
            border-top: 1px dashed #e2e8f0;  
            max-height: 250px;
            overflow-y: auto;
            }
            
            .desktop-accordion-body::-webkit-scrollbar {
            width: 6px;
            }
            .desktop-accordion-body::-webkit-scrollbar-track {
            background: #f1f5f9; 
            border-radius: 4px;
            }
            .desktop-accordion-body::-webkit-scrollbar-thumb {
            background: #cbd5e1; 
            border-radius: 4px;
            }
            .desktop-accordion-body::-webkit-scrollbar-thumb:hover {
            background: #94a3b8; 
            }

            /* Container for rows */
            .desktop-info-rows {
            display: flex;
            flex-direction: column;
            }
            
            .desktop-info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0; 
            border-bottom: 1px dashed #e2e8f0;  
            }
            
            .desktop-info-row:last-child {
            border-bottom: none;
            }
            
            .desktop-info-key {
            font-size: 13px;
            font-weight: 500;
            color: #4a6582; 
            }
            
            .desktop-info-val {
            font-size: 13px;
            font-weight: 700;  
            color: #0a192f;  
            text-align: right;
            }

        .desktop-plain-info-container {
          padding: 8px 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .desktop-plain-info-title {
          font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 6px; border-bottom: 2px solid #e2e8f0; padding-bottom: 6px;
        }
        .desktop-plain-info-row {
          display: flex; justify-content: space-between; font-size: 13px; gap: 12px; padding-bottom: 6px; border-bottom: 1px dashed #f1f5f9;
        }
        .desktop-plain-info-row:last-child { border-bottom: none; }
        .desktop-plain-info-key { color: #64748b; font-weight: 600; flex-shrink: 0; }
        .desktop-plain-info-val { color: #0f172a; font-weight: 700; text-align: right; word-break: break-word; }

        .desktop-rm-card { padding: 12px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0; }
 
        .desktop-operations-scroll-box {
          max-height: 400px;
          overflow-y: auto;
          padding-right: 8px;
        }
        .desktop-operations-scroll-box::-webkit-scrollbar { width: 6px; }
        .desktop-operations-scroll-box::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        .desktop-ops-timeline { display: flex; flex-direction: column; width: 100%; box-sizing: border-box; }
        .desktop-ops-item { position: relative; padding-left: 36px; padding-bottom: 16px; }
        .desktop-ops-item.is-last, .desktop-ops-item:last-child { padding-bottom: 0; }
        .desktop-ops-dot { position: absolute; left: 0; top: 18px; width: 14px; height: 14px; border-radius: 50%; background: #3b82f6; box-shadow: 0 0 0 4px #dbeafe; z-index: 2; }
        .desktop-ops-line { position: absolute; left: 6px; top: 25px; bottom: -25px; width: 2px; background: #93c5fd; border-radius: 2px; z-index: 1; }
        
        .desktop-ops-item::before, .desktop-ops-item:last-child::before, .desktop-ops-item.is-last::before, .desktop-ops-item.is-last .desktop-ops-line { display: none !important; content: none !important; }
        
        /* Tighter Operations box */
        .desktop-ops-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 10px 12px; display: flex; flex-direction: column; gap: 4px; margin-bottom: 8px; }
        .desktop-ops-title { font-size: 14px; font-weight: 700; color: #0f172a; }
        .desktop-ops-person { font-size: 12px; font-weight: 500; color: #475569; }
        .desktop-ops-row { display: flex; gap: 12px; font-size: 12px; }
        .desktop-ops-key { color: #64748b; font-weight: 600; }
        .desktop-ops-val { color: #0f172a; font-weight: 700; }
 
        .desktop-certdoc-section { background: #ffffff; border-radius: 16px; padding: 20px; display: flex; flex-direction: column; gap: 16px; border: 1px solid #e2e8f0; box-shadow: 0 2px 10px rgba(0,0,0,0.02); }
        .desktop-certdoc-title { font-size: 18px; font-weight: 700; color: #0f172a; border-bottom: 2px solid #f1f5f9; padding-bottom: 8px; }
        
        .desktop-certdoc-group { display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px; }
        .desktop-certdoc-heading { font-size: 13px; font-weight: 700; color: #475569; text-transform: uppercase; }
        .desktop-certdoc-chips { display: flex; flex-wrap: wrap; gap: 10px; }
        
        .desktop-certdoc-chip { display: inline-flex; align-items: center; gap: 8px; padding: 6px 12px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 13px; font-weight: 600; color: #0f172a; }
        .desktop-certdoc-doc { display: inline-flex; align-items: center; gap: 8px; padding: 8px 12px; background: #fff7ed; border: 1px solid #fdba74; border-radius: 6px; cursor: pointer; transition: all 0.2s ease; width: 100%; box-sizing: border-box; justify-content: space-between; }
        .desktop-certdoc-doc:hover { background: #ffedd5; transform: translateY(-2px); }
        .desktop-certdoc-doc-name { font-size: 13px; font-weight: 600; color: #c2410c; flex: 1; word-break: break-all; }
 
        .desktop-popup-btn { padding: 10px 16px; border-radius: 8px; font-size: 14px; font-weight: 600; border: none; cursor: pointer; text-align: center; }
        .desktop-popup-excel { background: #f0fdf4; color: #15803d; }
        .desktop-popup-excel:hover { background: #dcfce7; }
        .desktop-popup-json { background: #eff6ff; color: #1d4ed8; }
        .desktop-popup-json:hover { background: #dbeafe; }
        .desktop-popup-qr { background: #faf5ff; color: #7e22ce; }
        .desktop-popup-qr:hover { background: #f3e8ff; }

        .desktop-dev-footer { text-align: center; padding: 24px; font-size: 14px; color: #64748b; }
        .desktop-dev-footer strong { color: #ef4444; }
 
        .desktop-qr-modal { 
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; 
          background: rgba(15, 23, 42, 0.7); backdrop-filter: blur(4px);
          display: flex; align-items: center; justify-content: center; z-index: 9999; 
        }
        
        .desktop-qr-card-ui {
          background: #ffffff;
          border-radius: 24px;
          width: 340px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.25);
          display: flex;
          flex-direction: column;
        }

        .desktop-qr-card-header {
          background: linear-gradient(to bottom, #0f172a, #0db26b);
          border-bottom: 4px solid #fbbf24;
          padding: 24px 16px;
          text-align: center;
          color: #ffffff;
        }

        .desktop-qr-card-header h4 {
          margin: 0; font-size: 18px; font-weight: 800; letter-spacing: 1px;
        }

        .desktop-qr-card-header p {
          margin: 8px 0 0 0; font-size: 13px; font-weight: 500; opacity: 0.9;
        }

        .desktop-qr-card-body {
          padding: 32px 24px 20px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f8fafc;
        }

        .desktop-qr-wrapper {
          background: #ffffff;
          padding: 16px;
          border-radius: 16px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          margin-bottom: 24px;
          border: 1px solid #e2e8f0;
        }

        .desktop-qr-desc {
          font-size: 14px; color: #475569; margin: 0 0 24px 0; line-height: 1.5; font-weight: 500;
        }

        .desktop-qr-footer {
          font-size: 11px; font-weight: 700; color: #94a3b8; letter-spacing: 1px; margin: 0;
        }

        .desktop-qr-btn-row {
          display: flex; justify-content: center; gap: 16px; margin-top: 24px;
        }

        .desktop-qr-btn-download {
          background: #10b981; color: white; border: none; border-radius: 10px; padding: 12px 24px; font-weight: 700; cursor: pointer; font-size: 15px; transition: background 0.2s;
        }
        .desktop-qr-btn-download:hover { background: #059669; }

        .desktop-qr-btn-close {
          background: #3b82f6; color: white; border: none; border-radius: 10px; padding: 12px 24px; font-weight: 700; cursor: pointer; font-size: 15px; transition: background 0.2s;
        }
        .desktop-qr-btn-close:hover { background: #2563eb; }

        .desktop-impact-tile-mini {
          background: #ffffff;
          border-radius: 10px;
          padding: 10px 12px;
          display: flex;
          flex-direction: row; /* Icon left me aur text right me aayega */
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 8px rgba(0,0,0,0.02);
        }
       .desktop-impact-tile-mini .desktop-impact-tile-label {
          font-size: 10px; color: #64748b; font-weight: 700; text-transform: uppercase; line-height: 1; margin-bottom: 2px;
        }
        .desktop-impact-tile-mini .desktop-impact-tile-icon {
          width: 18px; height: 18px; color: #2563eb;
        }
        .desktop-impact-tile-mini .desktop-impact-tile-val {
          font-size: 13px; font-weight: 800; color: #0f172a; word-break: break-word; line-height: 1.2;
        }
 
.desktop-download-menu {
  position: absolute;
  right: 0;
  top: 100%;  
  margin-top: 8px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  padding: 8px;
  min-width: 160px;
  z-index: 50; 
}

/* Header styling */
.desktop-popup-header {
  font-size: 11px;
  font-weight: 700;
  color: #64748b; /* Slate grey */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 4px;
}
 
.desktop-popup-btn {
  display: block;
  width: 100%;
  text-align: center;
  padding: 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: opacity 0.2s ease, transform 0.1s ease;
}

.desktop-popup-btn:hover {
  opacity: 0.85;
}

.desktop-popup-btn:active {
  transform: scale(0.98);
}

/* Excel Button - Green */
.btn-excel {
  background-color: #ecfdf5; /* Light green bg */
  color: #059669; /* Dark green text */
}

/* JSON Button - Blue */
.btn-json {
  background-color: #eff6ff; /* Light blue bg */
  color: #2563eb; /* Dark blue text */
}
      `}</style>

            <div className="desktop-product-card">

                {/* 1. Left Side: Image & Logo */}
                <div className="desktop-product-left" ref={headerRef}>
                    <div ref={logoBoxRef}>
                        {brandLogoUrl && <img src={brandLogoUrl} alt="Brand Logo" className="desktop-brand-logo" />}
                    </div>
                    <div className="desktop-img-box" ref={imgBoxRef}>
                        <img ref={imgInnerRef} src={productImage || "https://via.placeholder.com/200"} alt={productDetails?.productId || "Product Image"} />
                        {roleId && (<button className="desktop-img-share-btn" onClick={() => setShowDownloadMenu(!showDownloadMenu)} title="Download Options">

                            <FileDownloadIcon style={{ fontSize: "20px", color: "#0f172a" }} />
                        </button>)}

                        {/* {(showDownloadMenu && roleId) && (
                            <div className="desktop-download-menu">
                                <div className="desktop-popup-header">Download Options</div>
                                {downloadReport && (
                                    <>
                                        <button
                                            className="desktop-popup-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(1);
                                                setShowDownloadMenu(false);
                                            }}
                                        >
                                            Download Excel
                                        </button>
                                        <button
                                            className="desktop-popup-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(0);
                                                setShowDownloadMenu(false);
                                            }}
                                        >
                                            Download JSON
                                        </button>
                                    </>
                                )}
                            </div>
                        )} */}

                        {(showDownloadMenu && roleId) && (
                            <div className="desktop-download-menu">
                                <div className="desktop-popup-header">DOWNLOAD OPTIONS</div>

                                {downloadReport && (
                                    <>
                                        <button
                                            className="desktop-popup-btn btn-excel"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(1);
                                                setShowDownloadMenu(false);
                                            }}
                                        >
                                            Download Excel
                                        </button>
                                        <button
                                            className="desktop-popup-btn btn-json"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(0);
                                                setShowDownloadMenu(false);
                                            }}
                                        >
                                            Download JSON
                                        </button>
                                    </>
                                )}

                                {/* <button
            className="desktop-popup-btn btn-qr"
            onClick={(e) => {
                e.stopPropagation();
                setShowQR(true);
                setShowDownloadMenu(false);
            }}
        >
            QR Code
        </button> */}
                            </div>
                        )}

                    </div>
                </div>

                <div className="desktop-product-middle" style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                    <div className="desktop-product-title" style={{ margin: 0, paddingBottom: "12px", borderBottom: "1px solid #e2e8f0" }}>
                        Product Specifications
                    </div>

                    <div className="desktop-details-grid">
                        {(() => {
                            const pd = productDetails || {};
                            const t = (v) => (typeof v === "string" ? v.trim() : v) || "-";

                            const fields = [
                                { label: "Brand Name", value: pd.brandName || "—", show: true },
                                { label: "Collection/Model", value: pd.collectionModelType || pd.productId || "—", show: true },
                                { label: "GTIN NO", value: pd.gtinNumber || "—", show: Boolean(pd.gtinNumber) },
                                { label: "Serial / batch no", value: pd.serialNo || pd.batchNo || "—", show: Boolean(pd.serialNo || pd.batchNo) },
                                { label: "Description", value: pd.description || "—", show: true },
                                { label: "Manufacturer", value: pd.manufacturer || "—", show: true },
                                { label: "Made in", value: pd.madeIn || "—", show: true },
                                { label: "Quantity", value: pd.quantity ? `${pd.quantity} ${pd.quantityUOM || ""}` : "—", show: Boolean(pd.quantity) },
                                { label: "Size", value: pd.size || "—", show: Boolean(pd.size) },
                                { label: "Dimensions", value: pd.dimensions || "—", show: Boolean(pd.dimensions && (hasSteelIndustry || hasBatteryIndustry)) },
                                { label: "CE Marking", value: pd.ceMarking || "—", show: Boolean(pd.ceMarking && (hasSteelIndustry || hasBatteryIndustry)) },
                                { label: "Customer Part Number", value: t(pd.customerPartNumber), show: hasSteelIndustry },
                                { label: "Drawing Revision", value: t(pd.drawingRevision), show: hasSteelIndustry },
                                { label: "Material Grade", value: t(pd.materialGrade), show: hasSteelIndustry },
                                { label: "Casting Process", value: t(pd.castingProcess), show: hasSteelIndustry },
                                { label: "Nominal Voltage", value: t(pd.nominalVoltage), show: hasBatteryIndustry },
                                { label: "Power Rating", value: t(pd.powerRating), show: hasBatteryIndustry },
                                { label: "Rated Capacity", value: t(pd.ratedCapacity), show: hasBatteryIndustry },
                                { label: "Energy Density", value: t(pd.energyDensity), show: hasBatteryIndustry },
                                { label: "Battery Cell Format", value: t(pd.batteryCellFormat), show: hasBatteryIndustry },
                                { label: "Battery Chemistry", value: t(pd.batteryChemistry), show: hasBatteryIndustry },
                                { label: "Material", value: mainData?.mainCard?.rawMaterials?.join(", ") || "—", show: true },
                                { label: "Tests", value: mainData?.testingTypes?.join(", ") || "—", show: mainData?.testingTypes?.length > 0 },
                            ];

                            return fields.filter(f => f.show).map((item, idx) => (
                                <div key={idx} className="desktop-details-item">
                                    <span className="desktop-details-label">{item.label}</span>
                                    <span className="desktop-details-val">{item.value}</span>
                                </div>
                            ));
                        })()}
                    </div>
                </div>

                <div className="desktop-product-qr-panel" style={{
                    flex: "0 0 240px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "20px",
                    borderLeft: "1px solid #e2e8f0",
                    paddingLeft: "24px",
                    marginLeft: "8px"
                }}>

                    {/* Top part: QR Code */}
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", width: "100%" }}>
                        <div style={{
                            position: "relative", background: "#ffffff", padding: "6px",
                            borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 4px 12px rgba(0,0,0,0.04)"
                        }}>
                            <QRCodeSVG
                                size={110}
                                level="H"
                                value={`${window.location.origin}/${encodedPath}`}
                                style={{ display: "block" }}
                            />
                            {MiniLogo && (
                                <div style={{
                                    position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                                    width: "26px", height: "26px", backgroundColor: "#ffffff", borderRadius: "50%",
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }}>
                                    <img src={MiniLogo} crossOrigin="anonymous" alt="Logo" style={{ width: "80%", height: "80%", objectFit: "contain" }} />
                                </div>
                            )}
                        </div>

                        <button
                            onClick={() => setShowQR(true)}
                            style={{
                                background: "#3b82f6", color: "white", border: "none", borderRadius: "8px",
                                padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer",
                                width: "100%", transition: "background 0.2s", boxShadow: "0 2px 6px rgba(59,130,246,0.3)"
                            }}
                            onMouseOver={(e) => e.target.style.background = "#2563eb"}
                            onMouseOut={(e) => e.target.style.background = "#3b82f6"}
                        >
                            Get QR Card
                        </button>

                    </div>

                    <div style={{ width: "100%", borderTop: "1px dashed #cbd5e1", paddingTop: "16px" }}>
                        <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a", marginBottom: "12px", textAlign: "center" }}>
                            Environmental Impact
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "10px" }}>

                            {/* CO2 Footprint */}
                            <div className="desktop-impact-tile-mini">
                                <div style={{ background: "#dcfce7", color: "#16a34a", padding: "8px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" /><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" /></svg>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <span className="desktop-impact-tile-label">CO₂</span>
                                    <span className="desktop-impact-tile-val">{co2Value} {co2Value !== "—" && <span style={{ fontSize: "10px" }}>kg</span>}</span>
                                </div>
                            </div>

                            {/* Energy Usage */}
                            <div className="desktop-impact-tile-mini">
                                <div style={{ background: "#fef3c7", color: "#d97706", padding: "8px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <span className="desktop-impact-tile-label">Energy</span>
                                    <span className="desktop-impact-tile-val">{energyValue} {energyValue !== "—" && <span style={{ fontSize: "10px" }}>kWh</span>}</span>
                                </div>
                            </div>

                            {/* Water Usage */}
                            <div className="desktop-impact-tile-mini">
                                <div style={{ background: "#dbeafe", color: "#2563eb", padding: "8px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" /></svg>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <span className="desktop-impact-tile-label">Water</span>
                                    <span className="desktop-impact-tile-val">{waterValue} {waterValue !== "—" && <span style={{ fontSize: "10px" }}>L</span>}</span>
                                </div>
                            </div>

                            {/* Recyclability */}
                            <div className="desktop-impact-tile-mini">
                                <div style={{ background: "#f3e8ff", color: "#9333ea", padding: "8px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></svg>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    <span className="desktop-impact-tile-label">Recycle</span>
                                    <span className="desktop-impact-tile-val">{recyclabilityValue} {recyclabilityValue !== "—" && <span style={{ fontSize: "10px" }}>%</span>}</span>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>

            {hasHierarchy && (
                <div className="desktop-impact-container" style={{ width: "100%", marginBottom: "1px" }}>
                    <div className="desktop-impact-title">DPP Hierarchy Structure</div>
                    {/* <HierarchyNode node={treeMapData} isRoot={true}  handleRedirect={handleTreeRedirect} /> */}
                    <HierarchyNode
                        node={treeMapData}
                        isRoot={true}
                        handleRedirect={roleId ? handleTreeRedirect : null}
                    />
                </div>
            )}

            <div style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: "5px", alignItems: "start" }}>

                {roleId && (<div style={{ gridColumn: "span 8" }}>
                    <div className="desktop-lifecycle-container" style={{ margin: 0, height: "100%", boxSizing: "border-box" }}>
                        <div className="desktop-lifecycle-header">Product Lifecycle Journey</div>

                        <div className="desktop-tabs-wrapper" ref={tabsRef}>
                            {journeySteps.map((step) => {
                                if (!step.view) return null;
                                const stageData = mainData?.productLifecycleJourney?.[step.key];
                                const orderNumber = stageData?.orderNumber;
                                const isAvailable = !(!orderNumber || orderNumber === "n/a" || orderNumber === "");
                                return (
                                    <button
                                        key={step.key}
                                        className={`desktop-tab-btn ${selectedJourneyKey === step.key ? "active" : ""} ${isAvailable ? "" : "unavailable"}`}
                                        onClick={() => openJourneyStep(step)}
                                    >
                                        {stageData?.name || step.key}
                                    </button>
                                );
                            })}
                        </div>

                        {loading && (
                            <div style={{ padding: "50px", display: "flex", justifyContent: "center" }}>
                                <CircularProgress size={40} />
                            </div>
                        )}

                        {!loading && selectedJourneyKey && (
                            <div className="desktop-stage-split">

                                <div className="desktop-stage-col">

                                    {/* Borderless KPIs */}
                                    {(() => {
                                        const h = mobileActiveStep?.mainHeader || {};
                                        const isMfg = moduleName === "Manufacturing";
                                        const isEnv = moduleName === "Environmental Impact & Sustainability";
                                        const showImpact = isMfg || isEnv;
                                        const tiles = [
                                            h.plant && ["Location", h.location || "—"],
                                            ["Company Name", h.companyName || "—"],
                                            h.productionDate && [
                                                moduleName === "Manufacturing" ? "Date of Manufacturing" : moduleName === "Raw Material" ? "PO Date" : "Manufacturing Date",
                                                h.productionDate,
                                            ],
                                            hasIndustryId && [
                                                moduleName === "Raw Material" ? "Blend Ratio" : "Plant",
                                                moduleName === "Raw Material" ? h.blendRatio || "—" : h.plant || "—",
                                            ],
                                            showImpact && ["Energy Usage", `${formatFloat(h.energyUsage || h.electricityConsumption)} kWh`],
                                            showImpact && ["Water Usage", `${formatFloat(h.waterUsage || h.waterConsumption)} liters`],
                                            showImpact && ["Carbon Footprint", `${formatFloat(h.carbonFootprint)} kg CO₂`],
                                            h.recyclabilityScore && ["Recyclability", `${formatFloat(h.recyclabilityScore)} %`],
                                        ].filter(Boolean);

                                        if (tiles.length > 0) {
                                            return (
                                                <div className="desktop-kpi-grid">
                                                    {tiles.map(([label, value]) => (
                                                        <div key={label} className="desktop-kpi-card">
                                                            <span className="desktop-kpi-label">{label}</span>
                                                            <span className="desktop-kpi-val">{value}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        }
                                    })()}

                                    {isRawMaterialModule ? (
                                        uniqueRmItems.length > 0 && (
                                            <div className="desktop-material-card">
                                                <strong style={{ color: "#334155" }}>Materials Used :</strong>
                                                {uniqueRmItems.map((m, idx) => (
                                                    <span key={idx} className="desktop-material-chip clickable" onClick={() => { setSelectedMaterialData(m); setOpenMaterialModal(true); }}>
                                                        {m.rmItemCode}
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                    </span>
                                                ))}
                                            </div>
                                        )
                                    ) : (
                                        mobileActiveStep?.materialsUsed?.length > 0 && (
                                            <div className="desktop-material-card">
                                                <strong style={{ color: "#334155" }}>Materials Used :</strong>
                                                {mobileActiveStep.materialsUsed.map((m, idx) => (
                                                    <span key={idx} className="desktop-material-chip">{m}</span>
                                                ))}
                                            </div>
                                        )
                                    )}

                                    {/* Scrollable Operations */}
                                    {opsData?.length > 0 && (
                                        <div>
                                            <div className="desktop-plain-info-title">Operations</div>
                                            <div className="desktop-operations-scroll-box">
                                                <OperationsTimeline operationsData={opsData} />
                                            </div>
                                        </div>
                                    )}

                                    {moduleName === "Product Tests" && !hasIndustryId && !hasBatteryIndustry && rowsHaveData(chemRows) && (
                                        <div className="desktop-accordion">
                                            <div className="desktop-accordion-header" onClick={() => toggleSection("chemicalAnalysis")}>
                                                <span>Chemical Analysis</span>
                                                {openSections.chemicalAnalysis ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </div>
                                            {openSections.chemicalAnalysis && (
                                                <div className="desktop-accordion-body">
                                                    <div className="desktop-info-rows">
                                                        {chemRows.map(([label, value], i) => (
                                                            <div key={i} className="desktop-info-row">
                                                                <span className="desktop-info-key">{label}</span>
                                                                <span className="desktop-info-val">{value ?? "—"}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Raw Materials Details */}
                                    {mobileActiveStep?.rawMaterialsDetails?.length > 0 && (
                                        <div className="desktop-accordion">
                                            <div className="desktop-accordion-header" onClick={() => toggleSection("rawMaterialsDetails")}>
                                                <span>Raw Materials Details</span>
                                                {openSections.rawMaterialsDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </div>
                                            {openSections.rawMaterialsDetails && (
                                                <div className="desktop-accordion-body">
                                                    {mobileActiveStep.rawMaterialsDetails.map((material, i) => (
                                                        <div key={i} className="desktop-rm-card" style={{ cursor: isRawMaterialModule ? "pointer" : "default" }} onClick={() => { if (isRawMaterialModule) { setSelectedMaterialData(material); setOpenMaterialModal(true); } }}>
                                                            <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: 6, display: "flex", justifyContent: "space-between" }}>
                                                                <span>{material.rmItemCode}</span>
                                                                {isRawMaterialModule && <ExpandMoreIcon style={{ transform: "rotate(-90deg)", color: "#1d4ed8" }} />}
                                                            </div>
                                                            <div style={{ fontSize: 13, color: "#475569", marginBottom: 4 }}>Vendor: {material.vendorName} • Quantity: {material.quantity}</div>
                                                            <div style={{ fontSize: 13, color: "#475569" }}>PO: {material.poNumber} • GRN: {material.grnNumber}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Journey Timeline */}
                                    {mobileActiveStep?.journeyTimeline?.length > 0 && (
                                        <div className="desktop-accordion">
                                            <div className="desktop-accordion-header" onClick={() => toggleSection("journeyTimeline")}>
                                                <span>Journey Timeline</span>
                                                {openSections.journeyTimeline ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </div>
                                            {openSections.journeyTimeline && (
                                                <div className="desktop-accordion-body clean-journey-timeline">
                                                    <JourneyTimeline journeyTimelineData={mobileActiveStep.journeyTimeline} />
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>

                                {/* Internal Right: Detailed Info */}
                                <div className="desktop-stage-col">

                                    {/* Plain Detailed Information without Box */}
                                    {showDetailedInfo && rowsHaveData(detailRows) && (
                                        <div className="desktop-plain-info-container">
                                            <div className="desktop-plain-info-title">Detailed Information</div>
                                            {detailRows.map(([label, value], i) => (
                                                <div key={i} className="desktop-plain-info-row">
                                                    <span className="desktop-plain-info-key">{label}</span>
                                                    <span className="desktop-plain-info-val">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {showCareInstructions && rowsHaveData(careRows) && (
                                        <div className="desktop-plain-info-container">
                                            <div className="desktop-plain-info-title">Care And Use Instructions</div>
                                            {careRows.map(([label, value], i) => (
                                                <div key={i} className="desktop-plain-info-row">
                                                    <span className="desktop-plain-info-key">{label}</span>
                                                    <span className="desktop-plain-info-val">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Product Test Types */}
                                    {moduleName === "Product Tests" && hasProductTestData && (
                                        <div className="desktop-accordion">
                                            <div className="desktop-accordion-header" onClick={() => toggleSection("productTestTypes")}>
                                                <span>Product Test Types</span>
                                                {openSections.productTestTypes ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </div>
                                            {openSections.productTestTypes && (
                                                <div className="desktop-accordion-body">
                                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                                                        {hasIndustryId ? (
                                                            <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.textileTest, "textileTest")}>
                                                                Textile Test <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                            </span>
                                                        ) : hasBatteryIndustry ? (
                                                            <>
                                                                <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.thermalStabilityTest, "thermalStability")}>
                                                                    Thermal Stability Test <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                </span>
                                                                <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.shortCircuitOverchargeTest, "shortCircuitOverchargeTest")}>
                                                                    Short Circuit Test <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.notchimpactTest, "notchimpactTest")}>
                                                                    Notch Impact <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                </span>
                                                                <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.tensileTest, "tensileTest")}>
                                                                    Tensile Test <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                </span>
                                                                <span className="desktop-material-chip clickable" onClick={() => openTestModal(mobileActiveStep?.hardnessTest, "hardnessTest")}>
                                                                    Hardness Test <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {mobileActiveStep?.repairRecyclingInfo && (
                                        <div className="desktop-accordion">
                                            <div className="desktop-accordion-header" onClick={() => toggleSection("repairRecycle")}>
                                                <span>Repair & Recycle Info</span>
                                                {openSections.repairRecycle ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </div>
                                            {openSections.repairRecycle && (
                                                <div className="desktop-accordion-body">
                                                    <RepairRecycleModal repairRecyclingInfo={mobileActiveStep.repairRecyclingInfo} />
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}
                    </div>
                </div>)}

                <div style={{ gridColumn: roleId ? "span 4" : "span 12", display: "flex", flexDirection: "column", gap: "4px" }}>

                    {certGroups.length > 0 && (
                        <div className="desktop-certdoc-section">
                            <div className="desktop-certdoc-title">Certificates</div>
                            {certGroups.map((group) => (
                                <div key={group.title} className="desktop-certdoc-group">
                                    <div className="desktop-certdoc-heading">{group.title}</div>
                                    <div className="desktop-certdoc-chips">
                                        {group.items.map((name, i) => (
                                            <div key={i} className="desktop-certdoc-chip">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                <span>{name}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {(documentsList.length > 0 && roleId && viewValidation) && (
                        <div className="desktop-certdoc-section">
                            <div className="desktop-certdoc-title">Documents</div>
                            <div className="desktop-certdoc-group">
                                <div className="desktop-certdoc-heading">Available Files</div>
                                <div className="desktop-certdoc-chips" style={{ flexDirection: "column" }}>
                                    {documentsList.map((doc, idx) => (
                                        <div key={idx} className="desktop-certdoc-doc" onClick={() => handleDocumentClick(doc)}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <TextSnippetIcon style={{ fill: "#ea580c", fontSize: 20 }} />
                                                <span className="desktop-certdoc-doc-name">{doc?.name}</span>
                                            </div>
                                            <OpenInNewIcon style={{ fontSize: 16, color: "#64748b" }} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                </div>



            </div>
            {!roleId && (
                <div style={{ width: "100%", marginBottom: "16px" }}>
                    <MDButton
                        color="info"
                        variant="outlined"
                        fullWidth
                        onClick={handleViewMoreInfo}
                        sx={{
                            padding: "10px 16px",
                            fontSize: "14px",
                            minHeight: "40px",
                            textTransform: "none",
                            display: "inline-flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            borderRadius: "8px",
                        }}
                    >
                        {/* Lock Icon */}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>

                        View More Detail
                    </MDButton>
                </div>
            )}

            {/* FOOTER */}
            <div className="desktop-dev-footer">
                Developed and maintained by : <strong>Mobillor Technologies Pvt. Ltd.</strong>
            </div>

            <Dialog open={openMaterialModal} onClose={() => setOpenMaterialModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Raw Material Details</span>
                    {selectedMaterialData?.dppUrl && (
                        <MDButton
                            color="info"
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                let url = selectedMaterialData.dppUrl;
                                if (!/^https?:\/\//i.test(url)) {
                                    url = 'http://' + url;
                                }
                                window.open(url, "_blank", "noopener,noreferrer");
                            }}
                            sx={{
                                padding: "4px 12px",
                                fontSize: "12px",
                                minHeight: "30px",
                                textTransform: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px"
                            }}
                        >
                            View DPP
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </MDButton>
                    )}
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
                        {selectedMaterialData?.dppCode && (
                            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
                                <div style={{ fontSize: 13, color: "#64748b", marginBottom: 8, fontWeight: 600 }}>DPP Code</div>
                                <div onClick={() => handleViewClick(selectedMaterialData?.dppCode)} style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "8px 16px", background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: "8px", fontSize: "14px", fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>
                                    {selectedMaterialData?.dppCode}
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                </div>
                            </div>
                        )}
                        {[
                            ["Item Code", selectedMaterialData?.rmItemCode], ["Quantity", selectedMaterialData?.quantity], ["Batch/Serial Number", selectedMaterialData?.batch_serialNumber], ["Vendor Name", selectedMaterialData?.vendorName], ["Supplier Audits", selectedMaterialData?.supplierAudits], ["Traceability", selectedMaterialData?.traceability], ["Ethical Score", selectedMaterialData?.ethicalScore], ["Source Mapping", selectedMaterialData?.sourceMapping], ["Material Purity", selectedMaterialData?.materialPurity], ["PO Number", selectedMaterialData?.poNumber], ["Country Of Origin", selectedMaterialData?.countryOfOrigin],
                            ["Recycled Material", selectedMaterialData?.recycledMaterial ? `${selectedMaterialData.recycledMaterial} %` : null],
                            ...(hasIndustryId ? [["Bio Based Material", selectedMaterialData?.bioBasedMaterial ? `${selectedMaterialData.bioBasedMaterial} %` : null], ["Organic Cotton", selectedMaterialData?.organicCotton ? `${selectedMaterialData.organicCotton} %` : null]] : []),
                            ...(hasBatteryIndustry ? [["Mine Name", selectedMaterialData?.mineName], ["Mine Country", selectedMaterialData?.mineCountry], ["Refinery Name", selectedMaterialData?.refineryName], ["Refinery Country", selectedMaterialData?.refineryCountry]] : []),
                            ["PO Date", selectedMaterialData?.poDate ? new Date(selectedMaterialData.poDate).toLocaleDateString("en-CA").replace(/-/g, "/") : null], ["GRN Number", selectedMaterialData?.grnNumber],
                            ["GRN Date", selectedMaterialData?.grnDate ? (() => { const date = new Date(selectedMaterialData.grnDate); return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`; })() : null],
                        ].map(([label, value], i) => {
                            if (value === null || value === undefined) return null;
                            return (
                                <div key={i} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontSize: 14, color: "#64748b", fontWeight: 600 }}>{label}</div>
                                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{value || "—"}</div>
                                </div>
                            );
                        })}
                    </div>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenMaterialModal(false)} color="info" variant="contained">Close</MDButton>
                </DialogActions>
            </Dialog>

            {/* Test Details Modal */}
            <Dialog open={openViewItemsModal} onClose={() => setOpenViewItemsModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{testModalTitle}</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
                        {testType === "thermalStability" && thermalFields.map(([label, key, fmt], i) => {
                            const value = viewItemsData?.[key];
                            if (value === undefined || value === null || value === "") return null;
                            return (
                                <div key={`thermal-${i}`} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontSize: 14, color: "#64748b", fontWeight: 600 }}>{label}</div>
                                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{fmt(value)}</div>
                                </div>
                            );
                        })}
                        {testModalFields.map(([label, key, fmt], i) => {
                            const value = viewItemsData?.[key];
                            const isDefinedField = key === "hardnessMean" || key === "hardnessIndividualValues";
                            const present = isDefinedField ? value !== undefined : value !== undefined && value !== null && value !== "";
                            if (!present) return null;
                            return (
                                <div key={i} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontSize: 14, color: "#64748b", fontWeight: 600 }}>{label}</div>
                                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{isDefinedField ? value : fmt(value)}</div>
                                </div>
                            );
                        })}
                    </div>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenViewItemsModal(false)} color="info" variant="contained">Close</MDButton>
                </DialogActions>
            </Dialog>


            <QRCodeModal
                showQR={showQR}
                onClose={() => setShowQR(false)}
                encodedPath={encodedPath}
                MiniLogo={MiniLogo}
                dppCode={dppCode}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSubModulesByRoleId: (roleId, jwtToken) =>
            dispatch(getSubModulesByRoleId(roleId, jwtToken)),
        getAllDataForDpp: (dppCode, jwtToken) =>
            dispatch(getAllDataForDpp(dppCode, jwtToken)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DppDesktopView);